import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a05e3018&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./OrdersTableRow.scss?vue&type=style&index=0&id=a05e3018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05e3018",
  null
  
)

export default component.exports